import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchSharedCalculation, fetchPublicHospitalConfig } from "../lib/api";
import LetterheadDoc from "../components/LetterheadDoc";
import { Printer, Hospital } from "@phosphor-icons/react";

/** Public read-only share view (no auth). Accessible via WhatsApp/share link. */
export default function SharePage() {
  const { token } = useParams();
  const [doc, setDoc] = useState(null);
  const [cfg, setCfg] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    Promise.all([fetchSharedCalculation(token), fetchPublicHospitalConfig()])
      .then(([d, c]) => {
        setDoc(d);
        setCfg(c);
      })
      .catch((e) =>
        setErr(
          e?.response?.data?.detail ||
            "Link tidak ditemukan atau sudah kedaluwarsa.",
        ),
      );
  }, [token]);

  if (err) {
    return (
      <div
        className="min-h-screen flex items-center justify-center px-4"
        data-testid="share-error"
      >
        <div className="bg-white border border-slate-200 rounded shadow-sm p-8 max-w-md text-center">
          <Hospital
            size={32}
            weight="duotone"
            className="mx-auto text-slate-400 mb-3"
          />
          <div className="text-lg font-bold text-slate-900 mb-1">
            Link Tidak Tersedia
          </div>
          <div className="text-sm text-slate-600">{err}</div>
        </div>
      </div>
    );
  }
  if (!doc || !cfg) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Memuat...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100" data-testid="share-page">
      <div className="no-print bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-[900px] mx-auto px-4 py-3 flex items-center justify-between gap-2 flex-wrap">
          <div className="flex items-center gap-2">
            <Hospital size={18} weight="duotone" className="text-[#0A3F9A]" />
            <div>
              <div className="text-sm font-bold text-slate-900">{cfg.name}</div>
              <div className="text-[11px] text-slate-500 uppercase tracking-wider">
                Estimasi Biaya Operasi
              </div>
            </div>
          </div>
          <button
            onClick={() => window.print()}
            className="bg-[#0A3F9A] text-white px-4 py-2 rounded hover:bg-[#082F73] text-sm font-medium flex items-center gap-2"
            data-testid="btn-share-print"
          >
            <Printer size={16} weight="duotone" /> Cetak / PDF
          </button>
        </div>
      </div>

      <LetterheadDoc doc={doc} cfg={cfg} />

      <div className="no-print max-w-[900px] mx-auto px-4 py-4 text-xs text-slate-500 text-center">
        Halaman ini bersifat read-only dan dibagikan oleh tim admission.
      </div>
    </div>
  );
}
